import { beginSignIn } from "../discord/browserAuth.js";

interface SignInScreenProps {
  title: string;
  appPath: string;
  clientId: string;
  browserUrl: string;
  /** false ⇒ this app has no browser mode; tell the member to open it from Discord. */
  canSignIn: boolean;
  /** Optional notice (e.g. a failed sign-in) shown above the button. */
  message?: string;
}

/** Browser-mode landing screen: one button into Discord's own login. */
export function SignInScreen({ title, appPath, clientId, browserUrl, canSignIn, message }: SignInScreenProps): JSX.Element {
  return (
    <div className="signin-screen">
      <h1 className="signin-screen__title">{title}</h1>
      {canSignIn ? (
        <>
          <p className="signin-screen__text">Sign in with your Discord account to continue.</p>
          {message ? (
            <p className="signin-screen__error" role="alert">
              {message}
            </p>
          ) : null}
          <button
            type="button"
            className="signin-screen__btn"
            onClick={() => beginSignIn({ appPath, clientId, browserUrl, silent: false })}
          >
            Sign in with Discord
          </button>
        </>
      ) : (
        <p className="signin-screen__text">Please open {title} from Discord.</p>
      )}
    </div>
  );
}
